import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import {breakpoint} from "./breakpoints";

gsap.registerPlugin(ScrollTrigger);


// To use: add
//    class js-change-background-when-scrolled
//    attributes  data-bg-color  data-scrolled-bg-color data-bg-scroll-height data-no-scroll-trigger


if ($(window).innerWidth() > breakpoint('xl')) {
  $('.js-change-background-when-scrolled').each(function (i, el) {
    let bgColor = $(el).data('bg-color')
    let noScrollTrigger = $(el).data('no-scroll-trigger')
    let bgScrolledColor = $(el).data('scrolled-bg-color')
    let bgScrollHeight = $(el).data('bg-scroll-height')
    let scrollHeight = bgScrollHeight ? bgScrollHeight : $(el).outerHeight();


    if (noScrollTrigger) {
      gsap.fromTo(
        el,
        {backgroundColor: bgColor},
        {
          backgroundColor: bgScrolledColor,
          ease: 'none',
          scrollTrigger: el,
          duration: 4
        }
      )
    } else {
      let tl = gsap.timeline({
        scrollTrigger: {
          start: "top bottom",
          trigger: el,
          end: () => `+=` + scrollHeight,
          once: false,
          scrub: true
        }
      });
      tl.fromTo(el, {backgroundColor: bgColor}, {backgroundColor: bgScrolledColor, ease: 'none'})
    }

  })
} else {
  $('.js-change-background-when-scrolled').each(function (i, el) {
    let bgScrolledColor = $(el).data('scrolled-bg-color')
    $(this).css('background-color', bgScrolledColor)
  })
}
